/*
 * bm-search-page.js: the /search filters in the new collection pages' look, on Algolia's own facets.
 * Builder A, search v2, 16 Oct 2026. Spec: output/search-like-collections-2026-10-16/report.md, approach (a).
 *
 * Runs only when html has .bm-search-page (snippets/bm-search-gate.liquid adds it before the Algolia app scripts).
 * Owns: the facet order and names, open states, rows (checkbox, count, colour dot), 6 rows, a faded 7th and Show all,
 * list search, the Colour families (17 Oct), price bands and fields, the count, sort labels, applied chips, the rail head
 * and the phone Filter & sort dialog.
 * Does not touch: the product template, the configure widget or pagination (bm-search-cards.js).
 * Sends no analytics of its own, with one exception (18 Oct): a Colour family tick sends the Algolia "Filter Applied"
 * event a raw finish tick sends, through the app's own insights middleware (filterApplied below).
 */
(function () {
  'use strict';

  // One immutable strings object per call site, as native tagged templates provide.
  // Explicit calls survive Shopify CDN lowering without changing html's interpolations.
  function templateStrings(strings, raw) {
    Object.defineProperty(strings, 'raw', { value: Object.freeze(raw) });
    return Object.freeze(strings);
  }
  var HTML_STRINGS_1 = templateStrings(["<span class=\"bm-sf-dot\" style="," aria-hidden=\"true\"></span>"], ["<span class=\"bm-sf-dot\" style="," aria-hidden=\"true\"></span>"]);
  var HTML_STRINGS_2 = templateStrings(["<span class=\"bm-sf-dot bm-sf-dot--none\" aria-hidden=\"true\"></span>"], ["<span class=\"bm-sf-dot bm-sf-dot--none\" aria-hidden=\"true\"></span>"]);
  var HTML_STRINGS_3 = templateStrings(["<label class=\"ais-RefinementList-label bm-sf-row\"><input type=\"checkbox\" class=\"ais-RefinementList-checkbox bm-sf-input\" checked="," /><span class=\"bm-sf-box\" aria-hidden=\"true\"></span>","<span class=\"ais-RefinementList-labelText bm-sf-label\">","</span><span class=\"ais-RefinementList-count bm-sf-count\">","</span></label>"], ["<label class=\"ais-RefinementList-label bm-sf-row\"><input type=\"checkbox\" class=\"ais-RefinementList-checkbox bm-sf-input\" checked="," /><span class=\"bm-sf-box\" aria-hidden=\"true\"></span>","<span class=\"ais-RefinementList-labelText bm-sf-label\">","</span><span class=\"ais-RefinementList-count bm-sf-count\">","</span></label>"]);
  // A family row: the same row, with the family's name for the click handler and a partly ticked box.
  var HTML_FAMILY = templateStrings(["<label class=\"ais-RefinementList-label bm-sf-row\" data-bm-family=", " data-bm-part=", "><input type=\"checkbox\" class=\"ais-RefinementList-checkbox bm-sf-input\" checked=", " indeterminate=", " /><span class=\"bm-sf-box\" aria-hidden=\"true\"></span>", "<span class=\"ais-RefinementList-labelText bm-sf-label\">", "</span><span class=\"ais-RefinementList-count bm-sf-count\">", "</span></label>"], ["<label class=\"ais-RefinementList-label bm-sf-row\" data-bm-family=", " data-bm-part=", "><input type=\"checkbox\" class=\"ais-RefinementList-checkbox bm-sf-input\" checked=", " indeterminate=", " /><span class=\"bm-sf-box\" aria-hidden=\"true\"></span>", "<span class=\"ais-RefinementList-labelText bm-sf-label\">", "</span><span class=\"ais-RefinementList-count bm-sf-count\">", "</span></label>"]);
  var HTML_STRINGS_4 = templateStrings(["<span class=\"bm-sf-total\">","</span>"], ["<span class=\"bm-sf-total\">","</span>"]);

  var HTML_BRAND = templateStrings(['<span class="bm-sf-brand-tile" aria-hidden="true"><span class="bm-sf-brand-art"><img src=', ' alt="" width="64" height="26" loading="lazy" decoding="async" /></span></span>'], ['<span class="bm-sf-brand-tile" aria-hidden="true"><span class="bm-sf-brand-art"><img src=', ' alt="" width="64" height="26" loading="lazy" decoding="async" /></span></span>']);

  var root = document.documentElement;
  if (!root.classList.contains('bm-search-page') || window.__bmSearchPage) return;
  window.__bmSearchPage = true;

  // Artwork comes from the same read-only Liquid resolver used by collection filters.
  var searchBrands = new Map(), searchLogoFits = new Map(), failedSearchLogos = new Set();
  var brandManifest = document.querySelector('[data-bm-search-brands]');
  try {
    JSON.parse(brandManifest ? brandManifest.textContent : '[]').forEach(function (entry) {
      if (entry && typeof entry.vendor === 'string' && typeof entry.logo === 'string' && entry.logo) searchBrands.set(entry.vendor.trim().toLowerCase(), entry.logo);
    });
  } catch (error) { /* Missing/bad manifest preserves text-only native choices. */ }
  function searchBrandLogo(label) {
    var logo = searchBrands.get(String(label || '').trim().toLowerCase());
    return logo && !failedSearchLogos.has(logo) ? logo : null;
  }
  function brandKey(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  // Filter-only optical scale values match c153 collection filters; never replace merchant artwork.
  var searchLogoScales = {villeroyboch:1.5,johnsonsuisse:1.4,yale:1.25,phoenix:1.15,metlam:1.15,artaustralia:1.15,lockwood:1.15,alma:.94,meir:.92,aulic:.94};
 function fitSearchBrandLogo(box,img,vendor){
  var url=new URL(img.src,location.href);url.searchParams.set('width','160');var src=url.href;
  if(!searchLogoFits.has(src))searchLogoFits.set(src,new Promise(function(resolve){var probe=new Image();probe.crossOrigin='anonymous';probe.onload=function(){try{var scale=Math.min(1,600/probe.naturalWidth),w=Math.round(probe.naturalWidth*scale),h=Math.round(probe.naturalHeight*scale),canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;var ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(probe,0,0,w,h);var pixels=ctx.getImageData(0,0,w,h).data,l=w,r=-1,t=h,b=-1;for(var y=0;y<h;y++)for(var x=0;x<w;x++){var i=(y*w+x)*4;if(pixels[i+3]>24&&Math.min(pixels[i],pixels[i+1],pixels[i+2])<230){l=Math.min(l,x);r=Math.max(r,x);t=Math.min(t,y);b=Math.max(b,y)}}resolve(r>=l?{w:w,h:h,l:l,t:t,iw:r-l+1,ih:b-t+1}:null)}catch(error){resolve(null)}};probe.onerror=function(){resolve(null)};probe.src=src}));
  searchLogoFits.get(src).then(function(bounds){if(!bounds||!box.isConnected)return;var art=box.querySelector('.bm-sf-brand-art'),width=art.clientWidth,height=art.clientHeight;if(!width||!height)return;var factor=searchLogoScales[brandKey(vendor)]||1;var scale=Math.min(width*factor/bounds.iw,16*factor/bounds.ih,(box.clientWidth-4)/bounds.iw,height/bounds.ih);if(img.src!==src)img.src=src;Object.assign(img.style,{width:bounds.w*scale+'px',height:bounds.h*scale+'px',left:((width-bounds.iw*scale)/2-bounds.l*scale)+'px',top:((height-bounds.ih*scale)/2-bounds.t*scale)+'px'});if(!art.classList.contains('is-balanced'))art.classList.add('is-balanced')});
 }

  // Algolia collapses with attributes; our observer intentionally watches child lists only.
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.bm-sf-group--brand .ais-Panel-collapseButton, .bm-sf-group--colour .ais-Panel-collapseButton')) schedule();
  });

  function balanceSearchBrandLogos(rail) {
    rail.querySelectorAll('.bm-sf-brand-tile img').forEach(function (img) {
      var tile = img.closest('.bm-sf-brand-tile');
      if (img.dataset.bmSearchLogoFit || !tile.getBoundingClientRect().width) return;
      img.dataset.bmSearchLogoFit = 'true';
      function failed() { failedSearchLogos.add(img.getAttribute('src')); tile.hidden = true; }
      img.addEventListener('error', failed, { once: true });
      if (img.complete && !img.naturalWidth) { failed(); return; }
      var label = img.closest('label').querySelector('.bm-sf-label');
      fitSearchBrandLogo(tile, img, label ? label.textContent : '');
    });
  }

  /* ---------- Defaults. Each one is a constant. ---------- */

  // Styling per filter. `attribute` is the app's facet name. The ORDER on the page is the Algolia app's (see arrange()).
  // A filter switched off in the app is not shown.
  var GROUPS = [
    // A reserved first slot. Off until the Algolia app offers a product type facet; nothing is built from tags here.
    { id: 'type', attribute: 'product_type', label: 'Product type', on: true, openDesktop: true, search: true }, // shows only if switched on in the Algolia app
    // Colour keeps a search box on long lists: today's /search has one ("Search for Color"), so it stays (Core Rule).
    { id: 'colour', attribute: 'options.color', label: 'Colour', on: true, openDesktop: true, search: true, dots: true },
    { id: 'price', attribute: 'price', label: 'Price', on: true, openDesktop: true }, // open, as search had it before 16 Oct (Carlos, 17 Oct)
    { id: 'brand', attribute: 'vendor', label: 'Brand', on: true, openDesktop: true, search: true }, // open on desktop, as search had it before 16 Oct (Carlos, 17 Oct)
  ];
  var OPEN_ON_PHONES = true;        // phones open every group, as search did before 16 Oct (Carlos, 17 Oct: current opening defaults remain)
  var MIN_VALUES = 2;               // a group with fewer values for the query is hidden, unless one of them is chosen
  var ROWS = 6;                     // rows before the faded 7th and "Show all", as the collection filters (17 Oct)
  var COLOUR_STEP = 8;              // Colour reveals this many more per click (exception until search colours are grouped)
  var SEARCH_FROM = 10;             // a list gets its search box from this many values (the collection's rule)
  var ALL_VALUES = 1000;            // every value loads, so Show all and the search box work in the browser
  var VALUE_ORDER = ['count:desc', 'name:asc']; // a ticked value keeps its place in the list
  var PRICE_EDGES = [100, 250, 500, 1000, 2000]; // decision 30: round bands, a price on an edge belongs to the band below
  var PRICE_FIELDS = true;          // Min and Max fields under the bands
  var PRICE_SLIDER = true;          // 17 Oct: the app's price slider in the collection's look; false = the bands (not approved)
  var COLOUR_DOTS = true;           // a family dot before each raw finish that bm-colour-families.js maps
  // Colour families, as the collection filters (17 Oct): one row per family, a tick selects every finish of the
  // family (OR), the count is the family's own union (one batched count call, analytics off), and old exact-finish
  // URLs stay exact (the family then shows as partly selected). ?bm_colour_groups=0 shows today's raw finishes with
  // the app's own operator, as the collection's switch.
  var COLOUR_GROUPS = true;
  var SORT_LABELS = {               // the app's sort orders, by index suffix; today's labels, edit here to rename
    relevance: 'Relevance',
    title_asc: 'Title ascending',
    title_desc: 'Title descending',
    price_asc: 'Price ascending',
    price_desc: 'Price descending',
    published_at_desc: 'Created descending',
    published_at_asc: 'Created ascending',
    recently_ordered_count_desc: 'Most popular',
  };
  var PHONE = '(max-width: 768px)'; // the collection's phone breakpoint (768 and below; desktop from 769)
  var WORDS = {
    result: 'result', results: 'results', filterSort: 'Filter & sort', showResults: 'Show results',
    updating: 'Updating results\u2026', updatingName: 'Updating results, show when ready',
    close: 'Close filters', showAll: 'Show all', showMore: 'Show more', showFewer: 'Show fewer', sortBy: 'Sort by:', sortName: 'Sort results',
    min: 'Min', max: 'Max', minName: 'Minimum price', maxName: 'Maximum price', noMatch: 'No matching options.',
    selected: 'selected', search: 'Search ',
    searchResults: 'Search results', resultsWord: 'Results', forWord: 'for', go: 'Search',
  };

  // Colour families. The Colour family entries (Content > Metaobjects > Colour family) decide them when the page prints
  // them (snippets/bm-colour-families-data.liquid, read below), as on the collection filters. This list is the
  // fallback, the 20 Oct decided grouping, the same as the built-in list in assets/bm-colour-families.js, and with
  // entries it only names the finishes. The dot paints a raw finish (groups off) or its family (groups on). The index
  // values stay the raw finishes.
  var FAMILIES = [
    {"name":"White","paint":"#ffffff","values":["white","matte white","gloss white","alpine white","satin white","stone white","frost tear","opal matt","milano white","opal","silk matte white","white clear","caststone white","matte speckled","warm white","white terrazzo","pure white","white oak","white stone","sea salt white","arctic white","frost","matt white","matte pearl","opal matte","opaline","white copper","white wheat","alpine","clear ivory","ivory clear","sea salt","smoke white","snow","snow white","white brushed","white chrome","white crackle","white green"]},
    {"name":"Clear","paint":"repeating-conic-gradient(#fff 0% 25%,#dce3e4 0% 50%) 50%/7px 7px","values":["clear prism","clear"]},
    {"name":"Cream & Beige","paint":"#d8cbb3","values":["beige","sand","coast","poppyseed","matte clay","almond","matte sand","dusk","antique cream","butter","royal beige","taupe","linen","bone","ivory","cream","cream crackle","matte ivory","shale","earth","champagne cream","matte khaki","khaki","ivory antique gold"]},
    {"name":"Stone & Marble","paint":"linear-gradient(135deg,#fff 0%,#fff 40%,#c9cbcf 42%,#fff 46%,#f2f2f2 100%)","values":["marble","terrazzo","cloudy carrara","carrara","carrera marble","manyana","matte concrete","natural carrara"]},
    {"name":"Chrome","paint":"linear-gradient(135deg,#fbfcfd 0%,#9ea4ab 45%,#f1f3f5 60%,#7d848c 100%)","values":["chrome","satin chrome","polished chrome","brushed chrome","bright chrome","chrome white","chrome plated","chrome plate","chrome clear","chrome frost","stain chrome","chrome black"]},
    {"name":"Nickel & Steel","paint":"linear-gradient(135deg,#eef0f2 0%,#b5bac0 55%,#dfe2e5 100%)","values":["brushed nickel","stainless steel","dull brushed nickel","satin stainless steel","polished stainless steel","brushed stainless steel","silver","polished nickel","nickel","brits nickel","brushed nickel/chrome plated","silk silver","brushed","brushed aluminium","aluminium","aluminium brushed nickel","natural steel","satin","brushed steel","silver aluminium","vintage nickel","stainless steel look","316 stainless steel","nickel clear","nickel silver","polished nickel plate","satin nickel","warm brushed nickel","white nickel crystal","304 stainless steel","bright nickel","brushed stainless","frost nickel","nickel smoke","nickel white","satin anodized","satin nickel plate","silver black","silver grey","stainless steel/polished brass","white silver"]},
    {"name":"Grey & Gunmetal","paint":"linear-gradient(135deg,#6b6f74 0%,#3a3d41 60%,#55595e 100%)","values":["gunmetal","brushed gunmetal","brushed carbon","grey","graphite nickel","graphite","brushed iron","charcoal","smoke","smoke tear","pewter","storm","black titanium","stone","metallic grey","shadow gunmetal","georgian metal","matte grey","gunmetal grey","warm grey","titanium","moss grey","natural iron","titanium grey","meteor grey","brushed grey","anthracite grey","antique pewter","dark grey","european pewter","ash","matte light grey","carbon grey","light grey","mineral grey","titan","anthracite","brushed graphite","carbon","graphite grey","gun metal","vintage pewter","black pearl"]},
    {"name":"Black","paint":"#1d1d1d","values":["black","matte black","black oak","designer black","brushed black","satin black","pure black","designer matte black","manhattan black","midnight black","black smoke","antique black","black opal matt","black ace","gloss black","black terrazzo","black white","coal black","magma","pvd black","puro","black amber","black brass matt","black granite","chrome smoke black","matte black & gloss white","matte black & matte white","midnight","nero","nero marquina","onyx","black black","black opal","bracket black","brushed black metallic","darknight","black brushed nickel","black glass","pietra grey","black gold"]},
    {"name":"Gold & Brass","paint":"linear-gradient(135deg,#e9d49a 0%,#b8913f 60%,#d9bd72 100%)","values":["brushed gold","brushed brass","brushed brass gold","urban brass","tiger bronze","satin brass","gold","brushed satin brass","champagne","antique gold","brass","aged brass","classic gold","brushed matte brass","amber tear","matte brass","baltic brass","nordic gold","antique silver","matte gold","antique gold opal matt","champagne brass","black antique gold","eureka gold","gold black","brass gold","antique gold clear","bright gold","polished brass","yellow","amber","natural brass","aged gold opal matt","antique gold alabastro","argent gold","gold white","light brushed brass","antique gold clear black","antique gold smoke","antique gold white","blue antique gold","brown gold","brushed_brass","clear antique gold","gold ivory","grey antique gold","light gold","opal matt antique gold","white antique gold","brushed dark brass"]},
    {"name":"Bronze & Copper","paint":"linear-gradient(135deg,#e0a17c 0%,#a45a35 60%,#cf8a62 100%)","values":["brushed bronze","bronze","brushed copper","dark brushed brass","brushed rose gold","lustre bronze","rome bronze","tumbled antique brass","vintage antique brass","antique brass","ember bronze","copper","dark bronze","cuban bronze","rose gold","satin bronze","warm bronze","metallic golden brown","artisan copper","matte bronze","rust","antique bronze","antique bronze matte","english bronze","bright copper","old burnished brass","antique brass amber","antique copper","copper black","aged antique brass","antique copper copper","bronze clear","oil bronze","rustic brass"]},
    {"name":"Wood & Brown","paint":"linear-gradient(135deg,#c79a6a 0%,#9c6c40 100%)","values":["woodgrain","harvest oak","woodland oak","natural oak","sable walnut","walnut","oak","brown","white ochre","natural","bamboo","teak","wood","light oak","mia","dark brown","mocca brown","ash wood","brushed walnut","carita","max","acacia wood","mocca","natural ash","pine","raw american oak","raw walnut","teak light","walnut dark","aluminium oak","mocha","sapele wood","teal brown","tobacco","colour_walnut","natural earth"]},
    {"name":"Red & Terracotta","paint":"#a8412f","values":["terracotta","red","orange","tuscan","volcano red","chrome red","gloss red","red clay","light tan"]},
    {"name":"Pink","paint":"#e3b5b8","values":["rose quartz","pink","matte pink","champagne pink","matte rouge","plum"]},
    {"name":"Green","paint":"#5f7a5c","values":["green","olive","rivergum","matte olive","saltbush","matte green","morning green","forest","sage","forest green","ivy","cape verde","emerald green","matte forest","olive green"]},
    {"name":"Blue","paint":"#2f4f7f","values":["blue","matte blue","midnight blue","antique aqua","blue white","sorrento blue","navy"]},
    {"name":"Other","paint":"#e8eded","values":["other","others","mixed","multicolour"]},
    {"name":"Frameless","paint":"#e8eded","values":["frameless","frameless mirror"]}
  ];
  // 20 Oct: with entries, each finish's family is the entry whose "Always in this family" list names it, else the
  // earliest match word in its name (whole words, the longer word wins a tie), else Other. Entries also give the
  // order (Position) and the swatch. A finish this list doesn't name joins its family the first time results show it.
  var familyByRule = null;
  (function () {
    var node = document.getElementById('bm-colour-families-data'), entries = null;
    try { entries = node ? JSON.parse(node.textContent) : null; } catch (e) { entries = null; }
    if (!Array.isArray(entries)) return;
    function clean(a) { return (Array.isArray(a) ? a : []).map(function (v) { return String(v).trim().toLowerCase(); }).filter(Boolean); }
    var list = entries.filter(function (e) { return e && typeof e.name === 'string' && e.name.trim(); }).map(function (e, i) {
      return { name: e.name.trim(), paint: e.paint || '#e8eded', position: Number(e.position) || 0, order: i, handle: e.handle || '', words: clean(e.words), finishes: clean(e.finishes), values: [] };
    });
    if (!list.length) return;
    list.sort(function (a, b) { return a.position - b.position || a.order - b.order; });
    var exact = {}, words = [], other = null;
    list.forEach(function (f) {
      f.finishes.forEach(function (v) { if (!exact[v]) exact[v] = f; });
      if (!other && (f.handle === 'other' || f.name === 'Other')) other = f;
      f.words.forEach(function (w) {
        words.push({ re: new RegExp('(^|[^a-z])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?![a-z])'), len: w.length, family: f });
      });
    });
    familyByRule = function (label) {
      var key = String(label || '').trim().toLowerCase(), best = null;
      if (!key) return null;
      if (exact[key]) return exact[key];
      words.forEach(function (w) {
        var m = w.re.exec(key);
        if (!m) return;
        var at = m.index + m[1].length;
        if (!best || at < best.at || (at === best.at && w.len > best.len)) best = { at: at, len: w.len, family: w.family };
      });
      return best ? best.family : other;
    };
    var named = {};
    FAMILIES.forEach(function (f) { f.values.forEach(function (v) { if (named[v]) return; named[v] = 1; var g = familyByRule(v); if (g) g.values.push(v); }); });
    list.forEach(function (f) { f.finishes.forEach(function (v) { if (named[v]) return; named[v] = 1; f.values.push(v); }); });
    FAMILIES = list;
  })();

  /* ---------- Helpers ---------- */
  var phone = window.matchMedia(PHONE);
  var PAINT = {}, FAMILY_OF = {};
  FAMILIES.forEach(function (f) { f.values.forEach(function (v) { PAINT[v] = f.paint; FAMILY_OF[v] = f; }); });
  var LAST = PRICE_EDGES.length;    // bands are 0..LAST
  var state = { h1: null, hits: null, chosen: 0, price: null, priceFrom: null, priceSet: null, expanded: {}, query: {}, facets: null, chips: null, lastFocus: null, inert: [], refocus: null, off: false, started: false, closeWhenReady: false, listening: false };

  function isPhone() { return phone.matches; }
  function groupOf(name) {
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].on && GROUPS[i].attribute === name) return GROUPS[i];
    return null;
  }
  function groupById(id) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].id === id) return GROUPS[i]; return null; }
  function fmt(n) { return Number(n || 0).toLocaleString('en-AU'); }
  function money(n) { return '$' + Number(n).toLocaleString('en-AU', { maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function paintOf(label) { var k = String(label || '').trim().toLowerCase(); return PAINT[k] || (learnFinish(k) || {}).paint || null; }
  // A colour finish the list doesn't name (a new tag): with entries, the rule places it and it joins that family's
  // finishes from here on. Without entries it stays a loose row, as before. Only the colour list calls this.
  function learnFinish(label) {
    var k = String(label || '').replace(/^Colour_/i, '').trim().toLowerCase(), f = familyByRule && k ? familyByRule(k) : null;
    if (!f) return null;
    if (f.values.indexOf(k) < 0) f.values.push(k);
    FAMILY_OF[k] = f; PAINT[k] = f.paint;
    return f;
  }
  function normalise(v) { return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
  function matches(label, query) { var hay = normalise(label); return normalise(query).split(/\s+/).filter(Boolean).every(function (w) { return hay.indexOf(w) > -1; }); }
  function setAttr(node, name, value) { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); }
  function flag(node, name, on) { if (node && node.hasAttribute(name) !== on) node.toggleAttribute(name, on); }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function make(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html) n.innerHTML = html; return n; }
  function near(a, b) { return Math.abs(a - b) < 0.005; }
  // equal ends: open ends (plus or minus Infinity) match only themselves, finite ends within half a cent
  function same(a, b) { return a === b || (isFinite(a) && isFinite(b) && near(a, b)); }
  // Anything unexpected leaves the app's own search page in place: html.bm-sf-on gates every rule in the CSS.
  var said = false;
  function bail(reason) {
    state.off = true;
    root.classList.remove('bm-sf-on');
    slots(true); // 17 Oct: the header stops treating the bar as its second row
    if (!said && window.console) { said = true; console.warn('bm-search-page: ' + reason + '; the app\'s own filters stay.'); }
  }
  function wrapperOf(g) { return document.querySelector('[class~="ais-facet-' + encodeURIComponent(g.attribute) + '"]'); }

  /* ---------- Colour families (COLOUR_GROUPS) ---------- */
  var grouped = COLOUR_GROUPS && !/[?&]bm_colour_groups=0(?:&|$)/.test(location.search);
  // attribute: the widget's own (tags, from recent_items.js). byName: this context's families, name -> its finishes.
  // key and base: the count context (the results' own query without the colour filter). counts: key -> union counts.
  var fam = { attribute: null, byName: {}, key: null, base: null, counts: new Map(), busy: {} };
  // A2 prototype (17 Oct research, never pushed): a family is one word in the address bar (colour=black,white).
  // Reading the URL expands the word to every finish on the family's list; writing it folds complete families back.
  // Tags filters ignore letter case, so the list's lowercase names match the catalogue's tags as they are.
  var SHORT_URL = true, URL_KEY = 'colour';
  var BY_SLUG = {}, BY_NAME = {};
  FAMILIES.forEach(function (f) {
    f.slug = f.name.toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    BY_SLUG[f.slug] = f; BY_NAME[f.name] = f;
  });
  function lc(v) { return String(v || '').toLowerCase(); }
  function staticTags(f) { return f.values.map(function (v) { return 'Colour_' + v; }); }
  function completeIn(list, f) {
    var have = {};
    (list || []).forEach(function (v) { have[lc(v)] = 1; });
    return f.values.length > 0 && f.values.every(function (v) { return have['colour_' + v]; });
  }
  function compressRoute(route) {
    var attr = fam.attribute || 'tags', rl = route && route.refinementList, tags = rl && rl[attr];
    if (!Array.isArray(tags) || !tags.length) return route;
    var words = [], drop = {};
    FAMILIES.forEach(function (f) {
      if (!completeIn(tags, f)) return;
      words.push(f.slug);
      f.values.forEach(function (v) { drop['colour_' + v] = 1; });
    });
    if (!words.length) return route;
    var rest = tags.filter(function (v) { return !drop[lc(v)]; });
    var out = Object.assign({}, route), list = Object.assign({}, rl);
    if (rest.length) list[attr] = rest; else delete list[attr];
    if (Object.keys(list).length) out.refinementList = list; else delete out.refinementList;
    out[URL_KEY] = words.join(',');
    return out;
  }
  function expandRoute(route) {
    var raw = route && route[URL_KEY];
    if (!raw) return route;
    var attr = fam.attribute || 'tags', out = Object.assign({}, route);
    delete out[URL_KEY];
    var words = (Array.isArray(raw) ? raw.join(',') : String(raw)).split(',').map(function (w) { return lc(w).trim(); }).filter(Boolean);
    var rl = Object.assign({}, out.refinementList), tags = [].concat(rl[attr] || []);
    words.forEach(function (w) {
      var f = BY_SLUG[w];
      // an unknown word reads as one exact finish ("matte-black" is Matte Black), never ignored: a wrong link shows
      // a removable chip and 0 results instead of every product
      (f ? staticTags(f) : ['Colour_' + w.replace(/-/g, ' ')]).forEach(function (t) {
        if (tags.map(lc).indexOf(lc(t)) < 0) tags.push(t);
      });
    });
    rl[attr] = tags;
    out.refinementList = rl;
    return out;
  }
  function routingHook(options) {
    var routing = options && options.routing, sm = routing && routing.stateMapping;
    if (!grouped || !SHORT_URL || !sm || typeof sm.stateToRoute !== 'function' || typeof sm.routeToState !== 'function') return options;
    return Object.assign({}, options, { routing: Object.assign({}, routing, { stateMapping: {
      stateToRoute: function (uiState) { return compressRoute(sm.stateToRoute(uiState)); },
      routeToState: function (route) { return sm.routeToState(expandRoute(route)); },
    } }) });
  }
  var COUNT_DROP = ['page', 'hitsPerPage', 'facets', 'maxValuesPerFacet', 'attributesToRetrieve', 'attributesToHighlight',
    'attributesToSnippet', 'highlightPreTag', 'highlightPostTag', 'clickAnalytics', 'analytics', 'userToken', 'facetingAfterDistinct'];
  function familyOfValue(v) { return FAMILY_OF[String(v || '').replace(/^Colour_/, '').trim().toLowerCase()] || null; }
  // the app's chips carry their value URL-encoded (data-value="Colour_Matte%20Black")
  function chipValue(l, name) { var v = l.getAttribute(name) || ''; try { return decodeURIComponent(v); } catch (e) { return v; } }
  function countText(n) { return typeof n === 'number' ? fmt(n) : n === false ? '\u2014' : '\u2026'; }
  function mainHelper() { try { return window.algoliaShopify.instantsearch.search.mainIndex.getHelper(); } catch (e) { return null; } }
  // A colour entry of the results' facetFilters: on tags only the Colour_ values, on any other attribute all of them.
  function isColourFilter(f) {
    var a = fam.attribute;
    if (typeof f !== 'string' || !a || f.indexOf(a + ':') !== 0) return false;
    return a !== 'tags' || f.slice(a.length + 1).indexOf('Colour_') === 0;
  }
  // The count context: the search exactly as the results ran it, minus the colour filter and the display fields.
  function countBase(results) {
    var raw = results && results._rawResults && results._rawResults[0];
    if (!raw || typeof raw.params !== 'string' || !fam.attribute) return null;
    var out = {}, filters = [];
    new URLSearchParams(raw.params).forEach(function (v, k) { if (COUNT_DROP.indexOf(k) < 0) out[k] = v; });
    if (out.facetFilters) { try { filters = JSON.parse(out.facetFilters); } catch (e) { return null; } }
    if (!Array.isArray(filters)) filters = [filters];
    out.facetFilters = filters.filter(function (f) { return Array.isArray(f) ? !f.some(isColourFilter) : !isColourFilter(f); });
    return out;
  }
  function keyOf(o) { var k = {}; Object.keys(o).sort().forEach(function (x) { k[x] = o[x]; }); return JSON.stringify(k); }
  // transformItems: the raw finishes become one row per family, in the collection's order; a finish no family maps
  // keeps its own row after them. A family with one finish has that finish's exact count; two or more wait for the
  // union. A family is ticked when all its finishes are, and partly ticked when only some are (an old exact link).
  function familyItems(raw, meta) {
    var base = countBase(meta && meta.results);
    fam.base = base;
    fam.key = base ? keyOf(base) : null;
    var known = fam.key ? fam.counts.get(fam.key) : null;
    var helper = mainHelper(), a = fam.attribute;
    var refined = (helper && a && helper.state.disjunctiveFacetsRefinements[a]) || [];
    var groups = {}, loose = [], byName = {}, out = [];
    (raw || []).forEach(function (item) {
      var f = familyOfValue(item.label) || learnFinish(item.label);
      if (!f) loose.push(item); else (groups[f.name] || (groups[f.name] = [])).push(item);
    });
    FAMILIES.forEach(function (f) {
      var members = groups[f.name] || [];
      var present = members.filter(function (m) { return m.count > 0; });
      var on = refined.filter(function (v) { var x = familyOfValue(v); return x && x.name === f.name; }).length;
      if (!present.length && !on) return;
      var whole = completeIn(refined, f);
      byName[f.name] = { values: staticTags(f), labels: present.map(function (m) { return m.label; }), finishes: present.map(function (m) { return m.value || m.label; }), multi: present.length > 1 };
      var count = present.length === 1 ? present[0].count : !present.length ? 0 : known && f.name in known ? known[f.name] : null;
      out.push(Object.assign({}, present[0] || members[0], { label: f.name, highlighted: f.name, count: count, isRefined: whole, bmFamily: f.name, bmPaint: f.paint, bmMixed: on > 0 && !whole }));
    });
    fam.byName = byName;
    return out.concat(loose);
  }
  // One tick: every finish of the family on (OR), or, when all are on already, every finish of it off. One search.
  function toggleFamily(name) {
    var F = BY_NAME[name], helper = mainHelper(), a = fam.attribute;
    if (!F || !helper || !a || !helper.state.isDisjunctiveFacet(a)) return;
    var s = helper.state, all = completeIn(s.disjunctiveFacetsRefinements[a], F);
    if (!all) filterApplied(helper, a, name);
    s = clearFamilyState(s, name);
    if (!all) staticTags(F).forEach(function (t) { s = s.addDisjunctiveFacetRefinement(a, t); });
    helper.setState(s.setPage(0)).search();
  }
  // 18 Oct: the Insights event a raw tick sends. The app's refinementList sends "Filter Applied" through the insights
  // middleware when a value goes on (never when it goes off); a family tick sets the state directly, so the
  // middleware never saw it. This sends the same event through the same middleware (its client, user token and
  // algoliaSource), for the family's finishes in these results that are not on yet, as the index spells them,
  // at most 10 filters per event (Algolia's limit). Ticking a family off sends nothing, as a raw untick.
  var FILTERS_PER_EVENT = 10;
  function filterApplied(helper, a, name) {
    try {
      var search = window.algoliaShopify.instantsearch.search, f = fam.byName[name];
      if (!search || typeof search.sendEventToInsights !== 'function' || !f || !f.finishes) return;
      var on = {};
      (helper.state.disjunctiveFacetsRefinements[a] || []).forEach(function (v) { on[lc(v)] = 1; });
      var values = f.finishes.filter(function (v) { return !on[lc(v)]; });
      var index = (helper.lastResults && helper.lastResults.index) || helper.state.index;
      for (var i = 0; i < values.length; i += FILTERS_PER_EVENT) {
        search.sendEventToInsights({
          insightsMethod: 'clickedFilters', widgetType: 'ais.refinementList', eventType: 'click', eventModifier: 'internal', attribute: a,
          payload: { eventName: 'Filter Applied', index: index, filters: values.slice(i, i + FILTERS_PER_EVENT).map(function (v) { return a + ':' + v; }) },
        });
      }
    } catch (e) {}
  }
  function clearFamilyState(s, name) {
    var a = fam.attribute;
    (s.disjunctiveFacetsRefinements[a] || []).slice().forEach(function (v) {
      var f = familyOfValue(v);
      if (f && f.name === name) s = s.removeDisjunctiveFacetRefinement(a, v);
    });
    return s;
  }
  // Family rows: the capture phase takes the click before the app's own handler, which would tick one finish only.
  document.addEventListener('click', function (e) {
    if (!grouped || state.off) return;
    var row = e.target.closest && e.target.closest('#bm-sf-rail [data-bm-family]');
    var chip = !row && e.target.closest && e.target.closest('#bm-sf-rail .ais-current-refined-values--link, #bm-sf-dialog .ais-current-refined-values--link');
    if (chip && !chip.bmFamily) return;
    if (!row && !chip) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (row) {
      var name = row.getAttribute('data-bm-family');
      if (document.activeElement && row.contains(document.activeElement)) state.familyFocus = { name: name, until: Date.now() + 3000 };
      return toggleFamily(name);
    }
    var helper = mainHelper();
    if (helper && fam.attribute && helper.state.isDisjunctiveFacet(fam.attribute)) helper.setState(clearFamilyState(helper.state, chip.bmFamily).setPage(0)).search();
  }, true);
  // Union counts: one batched call per count context, only while the Colour list is on screen, analytics off, kept
  // for the session. Ticking colours does not change the context, so it never asks again.
  var countWatch = window.IntersectionObserver ? new IntersectionObserver(function (list) { if (list.some(function (x) { return x.isIntersecting; })) schedule(); }) : null;
  var watched = null;
  function colourList() { var g = groupById('colour'), w = g && wrapperOf(g); return w && w.querySelector('.ais-RefinementList-list'); }
  function onScreen(n) {
    if (!n || !n.getClientRects().length || n.closest('[inert]') || getComputedStyle(n).visibility === 'hidden') return false;
    var r = n.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight;
  }
  function familyCounts() {
    if (!grouped || !fam.key || !fam.base) return;
    var list = colourList();
    if (countWatch && list !== watched) { if (watched) countWatch.unobserve(watched); watched = list; if (list) countWatch.observe(list); }
    var key = fam.key, known = fam.counts.get(key) || {};
    paintCounts(known);
    var need = Object.keys(fam.byName).filter(function (n) { return fam.byName[n].multi && !(n in known); });
    if (!need.length || fam.busy[key] || !onScreen(list)) return;
    var shop = window.algoliaShopify, client = shop && shop.instantsearch && shop.instantsearch.search && shop.instantsearch.search.client;
    if (!client || typeof client.search !== 'function') return;
    var index = ((shop.config && shop.config.index_prefix) || 'shopify_') + 'products', base = fam.base, a = fam.attribute;
    var requests = need.map(function (n) {
      var p = Object.assign({}, base, { hitsPerPage: 0, page: 0, analytics: false, clickAnalytics: false, attributesToRetrieve: [], attributesToHighlight: [], attributesToSnippet: [], responseFields: ['nbHits'] });
      p.facetFilters = base.facetFilters.concat([fam.byName[n].values.map(function (v) { return a + ':' + v; })]);
      return { indexName: index, params: p };
    });
    fam.busy[key] = true;
    function store(results) {
      var map = fam.counts.get(key) || {};
      need.forEach(function (n, i) { var r = results && results[i]; map[n] = r && typeof r.nbHits === 'number' ? r.nbHits : false; });
      fam.counts.set(key, map);
      if (fam.counts.size > 40) fam.counts.delete(fam.counts.keys().next().value);
    }
    Promise.resolve().then(function () { return client.search(requests); })
      .then(function (res) { store(res && res.results); }, function () { store(null); })
      .then(function () { delete fam.busy[key]; schedule(); });
  }
  function paintCounts(known) {
    document.querySelectorAll('#bm-sf-rail [data-bm-family]').forEach(function (row) {
      var n = row.getAttribute('data-bm-family'), f = fam.byName[n];
      if (f && f.multi && n in known) text(row.querySelector('.bm-sf-count'), countText(known[n]));
    });
  }
  // Applied chips: a whole family is one chip with the family's name, which clears the family. A partial family
  // (an old exact link, or a finish ticked before) keeps its exact finish chips, as the collection's.
  function familyChips(links) {
    var a = fam.attribute, names = new Map(), kept = {};
    if (!a) return names;
    var colour = links.filter(function (l) { return chipValue(l, 'data-attribute') === a && familyOfValue(chipValue(l, 'data-value')); });
    var on = colour.map(function (l) { return chipValue(l, 'data-value'); });
    colour.forEach(function (l) {
      var f = familyOfValue(chipValue(l, 'data-value'));
      var whole = !!f && f.values.length > 1 && completeIn(on, f);
      var li = l.closest('li'), dup = whole && !!kept[f.name];
      if (li) flag(li, 'hidden', dup);
      l.bmFamily = whole && !dup ? f.name : null;
      if (whole && !dup) { kept[f.name] = true; names.set(l, f.name); }
    });
    return names;
  }

  // Query context belongs to the results, so it stays visible when the header search field resets.
  // Read the completed Algolia result first: typing in autocomplete must not relabel old results.
  function resultQuery() {
    try {
      var search = window.algoliaShopify.instantsearch.search;
      var results = search.mainIndex.getResults();
      if (results && typeof results.query === 'string') return results.query.trim();
      if (search.helper && typeof search.helper.state.query === 'string') return search.helper.state.query.trim();
    } catch (e) {}
    try { return (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) { return ''; }
  }
  // 17 Oct, search-hero-field: phones also get the query as a field (CSS, 680.98px down, where the header shows only
  // its icon). A button, so it never takes focus itself: a tap opens the header's own search sheet with the query in it.
  // 18 Oct: every width shows the field (Carlos: "the same element we added in mobile should be also in desktop"),
  // drawn as the header's 18 Oct search bar with its Search button; on desktop a click opens the header's own search.
  // The heading leads with the result count ("44 results for “willow”"), the term in the teal accent.
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"/></svg>';
  // 18 Oct, search-hero-layout: the field has its own row at the top (bm-search-hero); the h1 holds only the heading
  // text and sits in the results' first row (headingPlace), so the page keeps one h1 that moves, never a copy.
  function queryHeading(p) {
    if (!p) return;
    var hero = p.querySelector(':scope > .bm-search-hero');
    if (!hero) {
      hero = make('div', 'bm-search-hero', '<button type="button" class="bm-search-query__field"><span class="bm-search-query__value"></span><span class="bm-search-query__go" aria-hidden="true">' + ICON_SEARCH + '<span>' + esc(WORDS.go) + '</span></span></button>');
      hero.querySelector('button').addEventListener('click', editQuery);
      p.insertBefore(hero, p.firstChild);
    }
    // the app's page template prints its own h1 ("Search result", class ais-h2), never shown: the theme's
    // new-template.css hides .ais-h2. It becomes a div with the same class and text, so the page has one h1.
    Array.prototype.forEach.call(p.querySelectorAll('h1.ais-h2'), function (old) {
      var d = document.createElement('div');
      Array.prototype.forEach.call(old.attributes, function (a) { d.setAttribute(a.name, a.value); });
      while (old.firstChild) d.appendChild(old.firstChild);
      old.parentNode.replaceChild(d, old);
    });
    var heading = state.h1;
    if (!heading) heading = state.h1 = make('h1', 'bm-search-query', '<span class="bm-search-query__count"></span> <span class="bm-search-query__for"><span class="bm-search-query__word"></span> <span class="bm-search-query__term"></span></span>');
    var query = resultQuery(), field = hero.querySelector('button'), n = state.hits;
    // textContent preserves punctuation and treats query markup as text.
    // The count is the results' own total, the stats widget's (the rail and the phone bar show the same). Until the
    // first answer the heading shows without it; while a new answer loads it keeps the last one.
    var count = !query ? WORDS.searchResults : typeof n === 'number' ? fmt(n) + ' ' + (n === 1 ? WORDS.result : WORDS.results) : WORDS.resultsWord;
    text(heading.querySelector('.bm-search-query__count'), count);
    text(heading.querySelector('.bm-search-query__word'), query ? WORDS.forWord : '');
    text(heading.querySelector('.bm-search-query__term'), query ? '“' + query + '”' : '');
    flag(heading.querySelector('.bm-search-query__for'), 'hidden', !query);
    text(field.firstChild, query);
    setAttr(field, 'aria-label', 'Change search: ' + query);
    flag(hero, 'hidden', !query);
  }
  // The heading's home: the rail head's first row on desktop (the sort goes under it), the phone bar in place of its
  // count (the count stays in the page, hidden, and the dialog keeps its own).
  function headingPlace(rail, b) {
    var h = state.h1;
    if (!h) return;
    var phoneNow = isPhone();
    var home = phoneNow ? b : rail && rail.querySelector(':scope > .bm-sf-head');
    if (!home) return;
    var before = phoneNow ? home.querySelector(':scope > .bm-sf-bar__open') : home.firstChild;
    if (h.parentNode !== home || (phoneNow ? h.nextSibling !== before : h !== home.firstChild)) home.insertBefore(h, before);
    if (b) flag(b.querySelector('.bm-sf-bar__count'), 'hidden', phoneNow);
  }
  // A plugin with only subscribe keeps autocomplete's setQuery. The tap sets the query first (the sheet keeps whatever
  // was typed last), then clicks the header's search button in the same tap: the sheet focuses its input at once, so
  // iOS raises the keyboard. 18 Oct (Carlos): the header field starts empty on /search (it was prefilled with the
  // query, so the page showed the term twice); the results field keeps the term and hands it to the header search.
  var setQuery = null;
  function optionsHook(options) {
    var q = resultQuery();
    if (!options || !q) return options;
    return Object.assign({}, options, {
      plugins: (options.plugins || []).concat({ name: 'bm-search-query', subscribe: function (params) { setQuery = params.setQuery; } }),
    });
  }
  function editQuery() {
    if (setQuery) setQuery(resultQuery());
    var open = Array.prototype.filter.call(document.querySelectorAll('.aa-DetachedSearchButton'), shown)[0];
    if (open) { open.click(); return; }
    // 18 Oct, desktop and tablet: the header's own field opens its search bar when it takes focus; scrolled down, the
    // sticky header shows its search icon instead, and that opens it. After this click has passed: the header closes
    // its search on any click outside its search box.
    var input = Array.prototype.filter.call(document.querySelectorAll('.algolia-search-box .aa-Input'), shown)[0];
    var icon = Array.prototype.filter.call(document.querySelectorAll('.site-nav__link--icon-search'), shown)[0];
    setTimeout(function () {
      if (icon) icon.click();
      else if (input) input.focus({ preventScroll: true });
    }, 0);
  }

  /* ---------- Order and names: the Algolia app decides (17 Oct) ---------- */
  // The admin owns search filters: the order, the names and which filters are on come from the Algolia app
  // (Search options > Facets), so a change there shows here. The theme only styles them. One exception keeps the
  // store's words: while a filter still has the app's default name (Vendor, Color, Type), it shows as Brand, Colour,
  // Product type. Any other name typed in the app is used as is. The market translations win over the config titles,
  // so both are read. All or nothing: it checks everything first and only then edits.
  var APP_DEFAULT_TITLES = { vendor: 'Vendor', 'options.color': 'Color', price: 'Price', product_type: 'Type' };
  function arrange(shop) {
    var cfg = shop.config && shop.config.facets;
    if (!Array.isArray(cfg) || !cfg.every(function (f) { return f && typeof f.name === 'string'; })) return false;
    var market = shop.shopify && shop.shopify.market && shop.shopify.market.translations;
    var lists = [cfg].concat(market && Array.isArray(market.facets) ? [market.facets] : []);
    GROUPS.forEach(function (g) {
      var titles = lists.map(function (list) { var f = list.filter(function (x) { return x && x.name === g.attribute; })[0]; return f && f.title; });
      var shown = titles[titles.length - 1] || titles[0];   // the market title wins in the app, as it does on the page
      var named = shown && shown !== APP_DEFAULT_TITLES[g.attribute];
      if (named) g.label = shown;                            // the admin's own name
      lists.forEach(function (list) { list.forEach(function (f) { if (f && f.name === g.attribute && !named) f.title = g.label; }); });
    });
    return true;
  }

  /* ---------- Hooks ---------- */
  function paramsHook(params, facet) {
    var g = facet && groupOf(facet.name);
    if (!g || !params) return params;
    // the price is set to the cent, so a band starts one cent above its lower edge (decision 30); the slider keeps the
    // app's whole dollars and drops the scale and tooltips, as the collection's price slider shows neither
    if (facet.type === 'slider') return Object.assign({}, params, PRICE_SLIDER ? { pips: false, tooltips: false } : { precision: 2 });
    var out = Object.assign({}, params, { limit: Math.max(params.limit || 0, ALL_VALUES), showMore: false, searchable: false, sortBy: VALUE_ORDER });
    // Colour families need OR inside the facet, as the collection's Colour filter. It is a query-time widget option
    // set here before the widgets start; the Algolia app's own settings stay as they are.
    if (g.id === 'colour' && grouped && typeof params.attribute === 'string') {
      fam.attribute = params.attribute;
      var own = params.transformItems;
      out.operator = 'or';
      out.transformItems = function (items, meta) { return familyItems(own ? own(items, meta) : items, meta); };
    }
    return out;
  }

  function chosenIn(g, o) {
    if (!o) return 0;
    if (g.id === 'price') return o.start && (isFinite(o.start[0]) || isFinite(o.start[1])) ? 1 : 0;
    return (o.items || []).filter(function (i) { return i.isRefined || i.bmMixed; }).length;
  }

  function tooFew(g, o) {
    if (!o || chosenIn(g, o)) return false;
    if (g.id === 'price') return !PRICE_SLIDER && bands(o).filter(function (b) { return b.count > 0; }).length < MIN_VALUES;
    return (o.items || []).length < MIN_VALUES;
  }

  function panelHook(options, facet) {
    var g = facet && groupOf(facet.name);
    if (!g) return options;
    var base = options || {}; // recent_items.js returns nothing here for list facets
    return Object.assign({}, base, {
      // A group with a chosen value always stays, so it can be undone. Otherwise it hides when it can't refine (the
      // app's own rule, which recent_items.js drops for list facets) or has fewer than MIN_VALUES values. The app's
      // hidden() isn't called: it would also set the wrapper's display, which is set here once instead.
      hidden: function (o) {
        if (g.id === 'price') state.price = o;
        var hide = !chosenIn(g, o) && (!(o && o.canRefine) || tooFew(g, o));
        var w = wrapperOf(g);
        var display = hide ? 'none' : '';
        if (w && w.style.display !== display) w.style.display = display;
        return hide;
      },
      collapsed: function () { return isPhone() ? !OPEN_ON_PHONES : !g.openDesktop; },
      templates: {
        header: function (o) {
          var n = chosenIn(g, o);
          return '<span class="bm-sf-title">' + esc(g.label) + '</span>' + (n ? '<span class="bm-sf-chosen" aria-hidden="true">' + n + '</span>' : '');
        },
        collapseButtonText: function () {
          return '<span class="bm-sf-sr">' + esc(g.label) + '</span><span class="bm-sf-pm" aria-hidden="true"></span>';
        },
        footer: g.id === 'price' ? (PRICE_SLIDER ? sliderFooter : priceFooter) : undefined,
      },
      cssClasses: { root: 'bm-sf-group bm-sf-group--' + g.id },
    });
  }

  function itemHook(template, item, html) {
    var g = item && groupOf(item.attribute);
    if (!g || typeof html !== 'function') return template;
    var dots = g.dots && COLOUR_DOTS;
    var paint = dots ? paintOf(item.label) : null;
    // a finish no family maps keeps an empty slot, so every name in the list starts at the same x
    var dot = !dots ? '' : paint ? html(HTML_STRINGS_1, 'background:' + paint) : html(HTML_STRINGS_2);
    var logo = g.id === 'brand' ? searchBrandLogo(item.label) : null;
    if (logo) dot = html(HTML_BRAND, logo);
    if (item.bmFamily) {
      var part = !!item.bmMixed;
      return html(HTML_FAMILY, item.bmFamily, part ? 'true' : null, !!item.isRefined, part, html(HTML_STRINGS_1, 'background:' + item.bmPaint), item.label, countText(item.count));
    }
    return html(HTML_STRINGS_3, !!item.isRefined, dot, item.label, fmt(item.count));
  }

  function statsHook(template, data, html) {
    if (!data || typeof data.nbHits !== 'number') return template;
    state.hits = data.nbHits;
    schedule();
    var words = fmt(data.nbHits) + ' ' + (data.nbHits === 1 ? WORDS.result : WORDS.results);
    return typeof html === 'function' ? html(HTML_STRINGS_4, words) : words;
  }

  // The app spreads the list into the arguments and adds its sort config last, so the orders are picked out by shape.
  function sortHook() {
    var list = Array.prototype.filter.call(arguments, function (o) { return o && typeof o === 'object' && !Array.isArray(o) && 'value' in o && 'label' in o; });
    return list.map(function (o, i) {
      var key = Object.keys(SORT_LABELS).filter(function (k) { return k !== 'relevance' && String(o.value).slice(-k.length - 1) === '_' + k; })[0] || (i === 0 ? 'relevance' : null);
      return key && SORT_LABELS[key] && SORT_LABELS[key] !== o.label ? Object.assign({}, o, { label: SORT_LABELS[key] }) : o;
    });
  }

  // Hooks register at once on the app's initialize event, and stay last in each chain: recent_items.js registers on
  // the same event, after this file, and its panel hook returns nothing for list facets, which would wipe ours. So
  // any later registration of a hook name used here is placed before ours.
  var MINE = {
    beforeInstantSearchFacetParamsOptions: paramsHook,
    beforeInstantSearchFacetPanelOptions: panelHook,
    beforeInstantSearchFacetItemTemplate: itemHook,
    beforeInstantSearchStatsTemplate: statsHook,
    beforeInstantSearchInitSearchSortOrders: sortHook,
    beforeAutocompleteOptions: optionsHook,
    beforeInstantSearchConfigurationOptions: routingHook,
  };
  function keepLast(hooks, name) {
    var key = (hooks.hookAliases && hooks.hookAliases[name]) || name;
    var list = hooks.registeredHooks && hooks.registeredHooks[key];
    var fn = MINE[key];
    if (!fn || !Array.isArray(list)) return;
    var i = list.indexOf(fn);
    if (i > -1 && i < list.length - 1) { list.splice(i, 1); list.push(fn); }
  }
  function initialize() {
    if (state.started) { if (window.console) console.warn('bm-search-page: the Algolia initialize event fired again; the first setup stays.'); return; }
    state.started = true;
    var shop = window.algoliaShopify;
    var hooks = shop && shop.hooks;
    if (!hooks || typeof hooks.registerHook !== 'function' || !hooks.registeredHooks) return bail('the Algolia hook registry is missing');
    if (shop.facets || shop.instantsearch) return bail('the Algolia app had already built its facets');
    if (!arrange(shop)) return bail('the Algolia facet config is not in the expected shape');
    var register = hooks.registerHook;
    hooks.registerHook = function (name) {
      var out = register.apply(this, arguments);
      keepLast(hooks, name);
      return out;
    };
    Object.keys(MINE).forEach(function (name) { register.call(hooks, name, MINE[name]); });
  }
  // If the app initialised before this file ran (it should load first, from the gate), nothing is half-applied.
  if (window.algoliaShopify && window.algoliaShopify.hooks_has_initialize) bail('the Algolia app initialised before this file loaded');
  else {
    root.classList.add('bm-sf-on');
    document.addEventListener('algolia.hooks.initialize', initialize);
  }

  /* ---------- Price: 6 round bands plus Min and Max, one numeric price refinement ---------- */
  function priceValues(o) {
    var r = o && o.results;
    if (!r) return null;
    var all = (r.disjunctiveFacets || []).concat(r.facets || []);
    for (var i = 0; i < all.length; i++) if (all[i].name === 'price') return all[i].data || {};
    return null;
  }
  function bandLabel(i) {
    if (i === 0) return 'Under ' + money(PRICE_EDGES[0]);
    if (i === LAST) return 'Above ' + money(PRICE_EDGES[LAST - 1]);
    return money(PRICE_EDGES[i - 1]) + ' - ' + money(PRICE_EDGES[i]);
  }
  function bands(o) {
    var values = priceValues(o) || {};
    var list = [];
    for (var i = 0; i <= LAST; i++) list.push({ i: i, lo: i === 0 ? -Infinity : PRICE_EDGES[i - 1], hi: i === LAST ? Infinity : PRICE_EDGES[i], label: bandLabel(i), count: 0 });
    Object.keys(values).forEach(function (k) {
      var v = parseFloat(k);
      if (!isFinite(v)) return;
      for (var i = 0; i <= LAST; i++) if (v > list[i].lo && v <= list[i].hi) { list[i].count += values[k]; break; }
    });
    return list;
  }
  function current(o) {
    var s = (o && o.start) || [];
    return [isFinite(s[0]) ? s[0] : -Infinity, isFinite(s[1]) ? s[1] : Infinity];
  }
  // Which bands the chosen price covers. None while the price came from the fields, or doesn't sit on band edges.
  function ticked(o) {
    if (PRICE_SLIDER) return []; // no bands: the chip reads the two ends
    var c = current(o);
    if (c[0] === -Infinity && c[1] === Infinity) return [];
    if (state.priceFrom === 'fields' && state.priceSet && same(state.priceSet[0], c[0]) && same(state.priceSet[1], c[1])) return [];
    var lowOk = c[0] === -Infinity || PRICE_EDGES.some(function (e) { return near(c[0], e + 0.01); });
    var highOk = c[1] === Infinity || PRICE_EDGES.some(function (e) { return near(c[1], e); });
    if (!lowOk || !highOk) return [];
    return bands(o).filter(function (b) { var lo = b.lo === -Infinity ? -Infinity : b.lo + 0.01; return lo >= c[0] - 0.005 && b.hi <= c[1] + 0.005; }).map(function (b) { return b.i; });
  }
  function shownBands(o) {
    var r = (o && o.range) || {};
    var t = ticked(o);
    return bands(o).filter(function (b) { return b.count > 0 || (t.indexOf(b.i) > -1 && b.hi >= r.min && b.lo < r.max); });
  }
  function fieldValue(v, end) {
    if (!isFinite(v)) return '';
    var n = end === 0 && PRICE_EDGES.some(function (e) { return near(v, e + 0.01); }) ? Math.floor(v) : v;
    return String(Math.round(n * 100) / 100);
  }
  function priceFooter(o) {
    state.price = o;
    var t = ticked(o);
    var c = current(o);
    var rows = shownBands(o).map(function (b) {
      var on = t.indexOf(b.i) > -1;
      return '<li class="bm-sf-item' + (on ? ' bm-sf-item--on' : '') + '"><button type="button" class="bm-sf-row bm-sf-band" role="checkbox" aria-checked="' + on + '" data-band="' + b.i + '"><span class="bm-sf-box" aria-hidden="true"></span><span class="bm-sf-label">' + esc(b.label) + '</span><span class="bm-sf-count">' + fmt(b.count) + '</span></button></li>';
    }).join('');
    var fields = PRICE_FIELDS ? '<div class="bm-sf-range">' +
      '<label class="bm-sf-field"><span class="bm-sf-unit" aria-hidden="true">$</span><input class="bm-sf-min" type="text" inputmode="decimal" autocomplete="off" placeholder="' + WORDS.min + '" aria-label="' + WORDS.minName + '" value="' + fieldValue(c[0], 0) + '"></label>' +
      '<span class="bm-sf-split" aria-hidden="true">-</span>' +
      '<label class="bm-sf-field"><span class="bm-sf-unit" aria-hidden="true">$</span><input class="bm-sf-max" type="text" inputmode="decimal" autocomplete="off" placeholder="' + WORDS.max + '" aria-label="' + WORDS.maxName + '" value="' + fieldValue(c[1], 1) + '"></label>' +
      '</div>' : '';
    return '<div class="bm-sf-price"><ul class="bm-sf-list bm-sf-bands">' + rows + '</ul>' + fields + '</div>';
  }
  function applyPrice(min, max, from) {
    var o = state.price;
    if (!o || typeof o.refine !== 'function') return;
    // the footer redraws with the new price; keep the keyboard where it was
    var a = document.activeElement;
    if (a && a.closest && a.closest('.bm-sf-price')) {
      state.refocus = a.matches('.bm-sf-band') ? '.bm-sf-band[data-band="' + a.getAttribute('data-band') + '"]' : a.matches('.bm-sf-min') ? '.bm-sf-min' : a.matches('.bm-sf-max') ? '.bm-sf-max' : null;
      state.refocusUntil = Date.now() + 3000;
    }
    state.priceFrom = from;
    state.priceSet = [min === undefined ? -Infinity : min, max === undefined ? Infinity : max];
    o.refine([min, max]);
  }
  // Ticking a band widens the choice to cover it; unticking one shrinks it from that end. The choice is always one
  // continuous range, because the app's price filter is one range.
  function pickBand(i) {
    var o = state.price;
    if (!o) return;
    var t = ticked(o).filter(function (x) { return shownBands(o).some(function (b) { return b.i === x; }); });
    var lo, hi;
    if (t.indexOf(i) > -1) {
      if (t.length === 1) return applyPrice(undefined, undefined, 'bands');
      lo = t[0]; hi = t[t.length - 1];
      if (i === lo) lo++; else hi = i - 1;
    } else {
      lo = t.length ? Math.min(t[0], i) : i;
      hi = t.length ? Math.max(t[t.length - 1], i) : i;
    }
    var r = o.range || {};
    var min = lo === 0 ? undefined : PRICE_EDGES[lo - 1] + 0.01;
    var max = hi === LAST ? undefined : PRICE_EDGES[hi];
    if (min !== undefined && isFinite(r.min) && min <= r.min) min = undefined;
    if (max !== undefined && isFinite(r.max) && max >= r.max) max = undefined;
    applyPrice(min, max, 'bands');
  }
  function readField(input) {
    var v = parseFloat(String(input && input.value || '').replace(/[^0-9.]/g, ''));
    return isFinite(v) ? v : undefined;
  }
  function applyFields(box) {
    var o = state.price;
    if (!o || !box) return;
    var min = readField(box.querySelector('.bm-sf-min')), max = readField(box.querySelector('.bm-sf-max'));
    var c = current(o), r = o.range || {};
    if (min !== undefined && max !== undefined && min > max) { var x = min; min = max; max = x; }
    // A band starts one cent above its edge and the field shows the edge; if that Min is left as shown, the band's
    // exact start is kept. Any other Min is taken as typed (123.45 stays 123.45, 123 stays 123).
    var bandStart = isFinite(c[0]) && PRICE_EDGES.some(function (e) { return near(c[0], e + 0.01); });
    if (min !== undefined && bandStart && min === Number(fieldValue(c[0], 0))) min = c[0];
    if (min !== undefined) { if (isFinite(r.min) && min <= r.min) min = undefined; else if (isFinite(r.max) && min > r.max) min = r.max; }
    if (max !== undefined) { if (isFinite(r.max) && max >= r.max) max = undefined; else if (isFinite(r.min) && max < r.min) max = r.min; }
    applyPrice(min, max, 'fields');
  }
  function clearPrice() { applyPrice(undefined, undefined, null); }
  function priceText() {
    var o = state.price;
    if (!o) return '';
    var c = current(o), t = ticked(o);
    if (t.length) {
      var a = t[0], b = t[t.length - 1];
      if (a === b) return bandLabel(a);
      if (a === 0) return 'Under ' + money(PRICE_EDGES[b]);
      if (b === LAST) return 'Above ' + money(PRICE_EDGES[a - 1]);
      return money(PRICE_EDGES[a - 1]) + ' - ' + money(PRICE_EDGES[b]);
    }
    var lo = isFinite(c[0]) ? money(fieldValue(c[0], 0)) : '', hi = isFinite(c[1]) ? money(c[1]) : '';
    if (lo && hi) return lo + ' - ' + hi;
    return lo ? 'From ' + lo : hi ? 'Up to ' + hi : '';
  }

  document.addEventListener('click', function (e) {
    var band = e.target.closest && e.target.closest('.bm-sf-band');
    if (band) { e.preventDefault(); pickBand(Number(band.getAttribute('data-band'))); }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches && t.matches('.bm-sf-min, .bm-sf-max')) {
      // typing clears the band ticks at once; the fields own the price from here
      var box = t.closest('.bm-sf-price');
      if (box) box.querySelectorAll('.bm-sf-band[aria-checked="true"]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.parentNode.classList.remove('bm-sf-item--on'); });
    }
  });
  document.addEventListener('change', function (e) {
    // a field the redraw has just replaced reports a change on its way out; the new one already holds the value
    if (e.target.matches && e.target.matches('.bm-sf-min, .bm-sf-max') && e.target.isConnected) applyFields(e.target.closest('.bm-sf-range'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.bm-sf-min, .bm-sf-max')) { e.preventDefault(); applyFields(e.target.closest('.bm-sf-range')); }
    else if (e.key === 'Tab') state.refocus = null;
  });
  // the shopper moving on elsewhere ends the focus hold at once
  document.addEventListener('pointerdown', function (e) { if (!(e.target.closest && e.target.closest('.bm-sf-price'))) state.refocus = null; }, true);

  /* ---------- Price slider, 17 Oct: the app's own range slider in the collection price group's look ---------- */
  // The collection shows one Min and Max bar above its slider. Here the bar is this footer (the same fields, names and
  // handlers as above) and the slider is the app's own, restyled in bm-search-page.css, which also puts the footer
  // above it. A drag, a key on a handle or a typed value all end in the app's one price refinement, so the URL, the
  // chip and Clear all work as before. The app's whole dollars: it rounds the low end down and the high end up.
  if (PRICE_SLIDER) root.classList.add('bm-sf-price-slider');
  var slid = { rail: null, key: null, until: 0 };
  function sliderNumber(v) { return isFinite(v) ? String(Math.round(v * 100) / 100) : ''; }
  function sliderField(cls, word, name, v) {
    return '<label class="bm-sf-field"><span class="bm-sf-unit" aria-hidden="true">$</span><input class="' + cls + '" type="text" inputmode="decimal" autocomplete="off" placeholder="' + word + '" aria-label="' + name + '" value="' + sliderNumber(v) + '"></label>';
  }
  // As the collection, the fields show the price range's two ends until one is chosen.
  function sliderFooter(o) {
    state.price = o;
    if (!PRICE_FIELDS) return '';
    var c = current(o), r = (o && o.range) || {};
    return '<div class="bm-sf-price bm-sf-price--slider"><div class="bm-sf-range">' +
      sliderField('bm-sf-min', WORDS.min, WORDS.minName, isFinite(c[0]) ? c[0] : r.min) +
      sliderField('bm-sf-max', WORDS.max, WORDS.maxName, isFinite(c[1]) ? c[1] : r.max) + '</div></div>';
  }
  // Handle names and dollar values for screen readers; while a handle moves, its field follows it, as the collection's.
  function sliderSync(rail, fields) {
    var g = rail.querySelector('.bm-sf-group--price');
    if (!g) return;
    Array.prototype.forEach.call(g.querySelectorAll('.rheostat-handle[data-handle-key]'), function (h) {
      var low = h.getAttribute('data-handle-key') === '0';
      var v = parseFloat(h.getAttribute('aria-valuenow'));
      if (!isFinite(v)) return;
      v = low ? Math.floor(v) : Math.ceil(v);
      setAttr(h, 'aria-label', low ? WORDS.minName : WORDS.maxName);
      setAttr(h, 'aria-valuetext', money(v));
      var input = fields && g.querySelector('.bm-sf-price--slider ' + (low ? '.bm-sf-min' : '.bm-sf-max'));
      if (input && input !== document.activeElement && input.value !== String(v)) input.value = String(v);
    });
  }
  var sliderWatch = new MutationObserver(function () { if (slid.rail) sliderSync(slid.rail, true); });
  // The app redraws both handles after each result, so a handle moved by keys gets the keyboard back.
  function slider(rail) {
    if (slid.rail !== rail) {
      sliderWatch.disconnect();
      sliderWatch.observe(rail, { attributes: true, attributeFilter: ['aria-valuenow'], subtree: true });
      slid.rail = rail;
    }
    sliderSync(rail, false);
    if (slid.key === null || Date.now() > slid.until) return;
    var a = document.activeElement;
    var h = rail.querySelector('.bm-sf-group--price .rheostat-handle[data-handle-key="' + slid.key + '"]');
    if (h && (!a || a === document.body || !a.isConnected)) h.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    var h = e.target.closest && e.target.closest('.bm-sf-group--price .rheostat-handle');
    slid.key = h && e.key !== 'Tab' ? h.getAttribute('data-handle-key') : null;
    slid.until = Date.now() + 3000;
  }, true);
  document.addEventListener('pointerdown', function () { slid.key = null; }, true);

  /* ---------- Page layout: rail head, chips, lists, phone bar and dialog ---------- */
  function page() { var r = document.getElementById('algolia-shopify-instantsearch'); return r && r.querySelector('.ais-page'); }
  // Only after the app has drawn its page: until then .ais-page is the app block's loading skeleton (it lists every
  // configured facet, enabled or not), which the app redraws in place and then drops the preload class.
  function facets(p) {
    if (state.facets && state.facets.isConnected) return state.facets;
    var r = document.getElementById('algolia-shopify-instantsearch');
    var f = p && p.querySelector('.ais-facets');
    if (!f || !r || r.classList.contains('ais-results-size-preload')) return null;
    if (!f.querySelector('.bm-sf-group')) {
      // the app drew its facets without our panel hook: leave its own page in place
      if (f.querySelector('.ais-Panel')) bail('the Algolia app drew its facets without the panel hook');
      return null;
    }
    f.id = 'bm-sf-rail';
    state.facets = f;
    return f;
  }

  // The count and sort at the top of the filter column, as the collection's rail head. The app's own containers move;
  // its widgets keep rendering into them. On phones the same head is the dialog's count and sort row.
  function railHead(p, rail) {
    var head = rail.querySelector(':scope > .bm-sf-head');
    if (!head) { head = make('div', 'bm-sf-head'); rail.insertBefore(head, rail.firstChild); }
    ['.ais-stats-container', '.ais-sort'].forEach(function (sel) {
      var node = p.querySelector('.ais-search-header > ' + sel);
      if (node) head.appendChild(node);
    });
    var sort = head.querySelector('.ais-sort');
    // the page template prints a loose "Sorted by" before the select; the collection has no such word
    if (sort) Array.prototype.forEach.call(sort.childNodes, function (n) { if (n.nodeType === 3 && n.nodeValue.trim()) n.nodeValue = ''; });
    var select = sort && sort.querySelector('select');
    if (select) {
      setAttr(select, 'id', 'bm-sf-sort');
      setAttr(select, 'aria-label', WORDS.sortName);
      if (!sort.querySelector(':scope > .bm-sf-sortby')) {
        var label = make('label', 'bm-sf-sortby');
        label.htmlFor = 'bm-sf-sort';
        label.textContent = WORDS.sortBy;
        sort.insertBefore(label, sort.firstChild);
      }
    }
  }

  // Applied filters as the collection's chips: the value alone, the group name for screen readers, one chip for the
  // price (the app prints its two ends), and "Clear all" after them from two chips up.
  // 17 Oct: on phones the chips sit above Show results, as the collection's (place() moves them), so the wrap is
  // found by reference as well as in the rail.
  function chips(rail) {
    var wrap = state.chips && state.chips.isConnected ? state.chips : rail.querySelector(':scope > .bm-sf-chips');
    var head = rail.querySelector(':scope > .bm-sf-head');
    if (!wrap) { wrap = make('div', 'bm-sf-chips'); rail.insertBefore(wrap, head ? head.nextSibling : rail.firstChild); }
    state.chips = wrap;
    var cur = rail.querySelector('.ais-current-refined-values-container') || wrap.querySelector('.ais-current-refined-values-container');
    var clr = rail.querySelector('.ais-clear-refinements-container') || wrap.querySelector('.ais-clear-refinements-container');
    if (cur && cur.parentNode !== wrap) wrap.appendChild(cur);
    if (clr && clr.parentNode !== wrap) wrap.appendChild(clr);
    if (cur && clr && cur.nextSibling !== clr) wrap.appendChild(clr);
    var links = Array.prototype.slice.call(wrap.querySelectorAll('.ais-current-refined-values--link'));
    var prices = links.filter(function (a) { return decodeURIComponent(a.getAttribute('data-attribute') || '') === 'price'; });
    prices.slice(1).forEach(function (a) { var li = a.closest('li'); if (li && !li.hidden) li.hidden = true; });
    if (prices[0] && !prices[0].bmPrice) {
      prices[0].bmPrice = true;
      prices[0].addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); clearPrice(); }, true);
    }
    var families = grouped ? familyChips(links) : null;
    links.forEach(function (a) {
      var body = a.querySelector(':scope > div');
      var label = body && body.querySelector('.ais-current-refined-values--label');
      if (!body || !label) return;
      var name = label.textContent.replace(/:\s*$/, '').trim();
      text(label, name + ': ');
      // a family chip shows the family; a colour chip that was one shows its own finish again
      var raw = families && familyOfValue(chipValue(a, 'data-value')) ? (chipValue(a, 'data-label') || chipValue(a, 'data-value')).replace(/^Colour_/, '') : null;
      var value = a === prices[0] ? priceText() : families && families.get(a) || raw;
      Array.prototype.forEach.call(body.childNodes, function (n) {
        if (n.nodeType !== 3 || !n.nodeValue.trim()) return;
        var v = value || n.nodeValue.replace(/^\s*:\s*/, '').replace(/Colour_/g, '').trim();
        if (n.nodeValue !== v) n.nodeValue = v;
      });
      setAttr(a, 'aria-label', 'Remove ' + name + ': ' + (value || body.textContent.replace(name + ': ', '').trim()));
    });
    var count = links.filter(function (a) { var li = a.closest('li'); return !li || !li.hidden; }).length;
    state.chosen = count;
    wrap.classList.toggle('bm-sf-chips--many', count >= 2);
    flag(wrap, 'hidden', count === 0);
  }

  // Lists: the search box from SEARCH_FROM values, 8 rows then "Show all" (chosen rows always show), as the collection.
  function lists() {
    GROUPS.forEach(function (g) {
      if (!g.on || g.id === 'price') return;
      var w = wrapperOf(g);
      var body = w && w.querySelector('.ais-Panel-body');
      if (!body) return;
      var list = body.querySelector('.ais-RefinementList-list');
      var rows = list ? Array.prototype.slice.call(list.children) : [];
      var query = state.query[g.id] || '';
      var box = body.querySelector(':scope > .bm-sf-search');
      var wantBox = g.search && (rows.length >= SEARCH_FROM || !!query);
      if (wantBox && !box) { box = searchBox(g); body.insertBefore(box, body.firstChild); }
      else if (!wantBox && box) { box.remove(); box = null; }
      if (list && !list.id) list.id = 'bm-sf-list-' + g.id;
      if (box) setAttr(box.querySelector('input'), 'aria-controls', list ? list.id : '');
      var found = 0;
      rows.forEach(function (row) {
        var label = row.querySelector('.bm-sf-label');
        var hay = label ? label.textContent : row.textContent;
        // a family row also answers to its finishes' names, so "matte black" still finds Black
        var family = grouped && g.id === 'colour' && row.querySelector('[data-bm-family]');
        var mine = family && fam.byName[family.getAttribute('data-bm-family')];
        if (mine) hay += ' ' + mine.labels.join(' ');
        var miss = !!query && !matches(hay, query);
        flag(row, 'data-bm-sf-miss', miss);
        if (!miss) found++;
      });
      if (box) {
        var empty = box.querySelector('.bm-sf-search__empty');
        var none = !!query && !found;
        text(empty, none ? WORDS.noMatch : '');
        flag(empty, 'hidden', !none);
      }
      // As the collection filters: more than 8 values shows 6, a faded 7th and "Show all" / "Show fewer" (17 Oct).
      var long = !query && rows.length > ROWS + 2 && !(grouped && g.id === 'colour');
      var stepped = g.id === 'colour' && !grouped; // exception: raw finish lists can run to 100+, so Colour steps (17 Oct)
      var open = !!state.expanded[g.id];
      var shown = stepped ? Math.max(ROWS, Number(state.expanded[g.id]) || ROWS) : (open ? rows.length : ROWS);
      var remaining = 0;
      rows.forEach(function (row, i) {
        var chosen = !!row.querySelector('input:checked');
        var limited = stepped ? shown < rows.length : !open;
        var peek = long && limited && i === shown && !chosen;
        var cut = long && limited && i > shown && !chosen;
        flag(row, 'data-bm-sf-peek', peek);
        if (row.inert !== peek) row.inert = peek;
        flag(row, 'data-bm-sf-cut', cut);
        if (cut) remaining++;
      });
      var more = body.querySelector(':scope > .bm-sf-more:not(.bm-sf-less)');
      var wantMore = long && (!stepped || shown < rows.length);
      if (wantMore && !more) {
        more = make('button', 'bm-sf-more' + (stepped ? ' bm-sf-more--step' : ''));
        more.type = 'button';
        more.addEventListener('click', function () {
          if (stepped) {
            // Reveal the next eight hidden options. Chosen options stay visible outside the batch.
            var current = body.querySelector('.ais-RefinementList-list');
            var next = Math.max(ROWS, Number(state.expanded[g.id]) || ROWS);
            var extra = 0;
            if (current) Array.prototype.forEach.call(current.children, function (row, i) {
              if (i < next || extra >= COLOUR_STEP) return;
              next = i + 1;
              if (!row.querySelector('input:checked')) extra++;
            });
            state.expanded[g.id] = next;
          } else state.expanded[g.id] = !state.expanded[g.id];
          lists();
          if (stepped && !more.isConnected) {
            var reset = body.querySelector(':scope > .bm-sf-less');
            if (reset) reset.focus({ preventScroll: true });
          }
        });
        body.appendChild(more);
      } else if (!wantMore && more) { more.remove(); more = null; }
      if (more) {
        var left = remaining + rows.filter(function (r) { return r.hasAttribute('data-bm-sf-peek'); }).length;
        text(more, stepped ? WORDS.showMore : (open ? WORDS.showFewer : WORDS.showAll));
        if (!stepped) setAttr(more, 'aria-expanded', String(open));
        if (list) setAttr(more, 'aria-controls', list.id);
      }
      var less = body.querySelector(':scope > .bm-sf-less');
      var wantLess = long && stepped && shown > ROWS;
      if (wantLess && !less) {
        less = make('button', 'bm-sf-more bm-sf-less');
        less.type = 'button';
        less.addEventListener('click', function () {
          state.expanded[g.id] = ROWS;
          lists();
          var next = body.querySelector(':scope > .bm-sf-more:not(.bm-sf-less)');
          if (next) next.focus({ preventScroll: true });
        });
        body.appendChild(less);
      } else if (!wantLess && less) { less.remove(); less = null; }
      if (less) {
        text(less, WORDS.showFewer);
        if (list) setAttr(less, 'aria-controls', list.id);
      }
    });
  }
  function searchBox(g) {
    var name = WORDS.search + g.label.toLowerCase();
    var box = make('div', 'bm-sf-search', '<div class="bm-sf-search__field"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 4.5 4.5"/></svg><input type="search" class="bm-sf-search__input" autocomplete="off" spellcheck="false"></div><p class="bm-sf-search__empty" role="status" hidden></p>');
    var input = box.querySelector('input');
    input.placeholder = name;
    input.setAttribute('aria-label', name);
    input.value = state.query[g.id] || '';
    var update = function () { state.query[g.id] = input.value; lists(); };
    input.addEventListener('input', function (e) { if (!e.isComposing) update(); });
    input.addEventListener('search', update);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { e.preventDefault(); e.stopPropagation(); input.value = ''; update(); }
    });
    return box;
  }

  // Phone: a sticky "N results | Filter & sort" bar over the results opens a full-screen dialog holding the rail.
  // 17 Oct: the collection bar's icon (bm-filters-mobile.css --bm-fi-sliders, Phosphor sliders-horizontal), drawn at 20px
  var ICON_FILTER = '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M40,88H73a32,32,0,0,0,62,0h81a8,8,0,0,0,0-16H135a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16Zm64-24A16,16,0,1,1,88,80,16,16,0,0,1,104,64ZM216,168H199a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16h97a32,32,0,0,0,62,0h17a8,8,0,0,0,0-16Zm-48,24a16,16,0,1,1,16-16A16,16,0,0,1,168,192Z"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M200 56 56 200M56 56l144 144" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round"/></svg>';
  var dialog = null;
  function bar(p) {
    var b = document.getElementById('bm-sf-bar');
    if (!b) {
      b = make('div', 'bm-sf-bar', '<span class="bm-sf-bar__count"></span><button type="button" class="bm-sf-bar__open" aria-haspopup="dialog" aria-controls="bm-sf-dialog" aria-expanded="false">' + ICON_FILTER + '<span>' + esc(WORDS.filterSort) + '</span><span class="bm-sf-bar__badge bm-sf-bar__badge--none" aria-hidden="true"></span></button>');
      b.id = 'bm-sf-bar';
      b.querySelector('button').addEventListener('click', openDialog);
    }
    var block = p.querySelector(':scope > .ais-block');
    if (block && b.nextSibling !== block) p.insertBefore(b, block);
    // the bar runs edge to edge, as the collection's: it reaches out over the page's own side padding
    if (isPhone()) {
      var r = p.getBoundingClientRect(), cs = getComputedStyle(p);
      var left = Math.round(r.left + parseFloat(cs.paddingLeft)) + 'px', right = Math.round(document.documentElement.clientWidth - r.right + parseFloat(cs.paddingRight)) + 'px';
      if (b.style.getPropertyValue('--bm-sf-gl') !== left) b.style.setProperty('--bm-sf-gl', left);
      if (b.style.getPropertyValue('--bm-sf-gr') !== right) b.style.setProperty('--bm-sf-gr', right);
    }
    return b;
  }
  function dialogEl() {
    if (dialog) return dialog;
    dialog = make('div', 'bm-sf-dialog', '<div class="bm-sf-dialog__head"><h2 class="bm-sf-dialog__title" id="bm-sf-dialog-title" tabindex="-1">' + esc(WORDS.filterSort) + '</h2><button type="button" class="bm-sf-dialog__close" aria-label="' + esc(WORDS.close) + '">' + ICON_CLOSE + '</button></div><div class="bm-sf-dialog__scroll"></div><div class="bm-sf-dialog__foot"><button type="button" class="bm-sf-dialog__show"></button></div>');
    dialog.id = 'bm-sf-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'bm-sf-dialog-title');
    dialog.hidden = true;
    dialog.querySelector('.bm-sf-dialog__close').addEventListener('click', function () { closeDialog(false); });
    // 1 Nov (c338): a tap while the results are updating closes the dialog once they arrive, as the collection's
    dialog.querySelector('.bm-sf-dialog__show').addEventListener('click', function () {
      if (searching()) { state.closeWhenReady = true; return; }
      closeDialog(true);
    });
    document.body.appendChild(dialog);
    observer.observe(dialog, { childList: true, subtree: true });
    return dialog;
  }
  function place(p, rail) {
    var wrap = state.chips && state.chips.isConnected ? state.chips : null;
    if (isPhone()) {
      var d = dialogEl(), scroll = d.querySelector('.bm-sf-dialog__scroll'), foot = d.querySelector('.bm-sf-dialog__foot');
      if (rail.parentNode !== scroll) scroll.appendChild(rail);
      // the chips go above Show results, as the collection's criteria row
      if (wrap && (wrap.parentNode !== d || wrap.nextSibling !== foot)) d.insertBefore(wrap, foot);
    } else {
      // back under the rail head on desktop
      var head = rail.querySelector(':scope > .bm-sf-head');
      if (wrap && wrap.parentNode !== rail) rail.insertBefore(wrap, head ? head.nextSibling : rail.firstChild);
      // widened to desktop with the dialog open: close it, and put the keyboard on a control that is still visible
      var wasOpen = isOpen();
      if (wasOpen) release();
      var block = p.querySelector(':scope > .ais-block');
      if (rail.parentNode !== p) p.insertBefore(rail, document.getElementById('bm-sf-bar') || block);
      if (wasOpen) focusFirst([rail.querySelector('.ais-SortBy-select'), rail.querySelector('.ais-Panel-collapseButton')], block);
    }
  }
  // The chips row fades at its right edge only while more chips sit past it, as the collection's (bm-tags-more-right).
  function chipFade() {
    var list = state.chips && state.chips.querySelector('.ais-current-refined-values--list');
    if (!list) return;
    var more = list.scrollWidth - list.clientWidth - list.scrollLeft > 2;
    if (list.classList.contains('bm-sf-chips-more') !== more) list.classList.toggle('bm-sf-chips-more', more);
  }
  document.addEventListener('scroll', function (e) {
    if (e.target instanceof Element && e.target.matches('.bm-sf-chips .ais-current-refined-values--list')) chipFade();
  }, true);
  function isOpen() { return !!dialog && !dialog.hidden; }
  function shown(n) { return !!n && n.isConnected && n.getClientRects().length > 0 && getComputedStyle(n).visibility !== 'hidden'; }
  // Focus the first visible control; failing that, the results block itself (made focusable for this only).
  function focusFirst(list, fallback) {
    for (var i = 0; i < list.length; i++) if (shown(list[i])) { list[i].focus({ preventScroll: true }); return; }
    if (fallback) { if (!fallback.hasAttribute('tabindex')) fallback.setAttribute('tabindex', '-1'); fallback.focus({ preventScroll: true }); }
  }
  // Undo everything opening did, and nothing else: no focus or scroll moves. Safe to call any number of times.
  function release() {
    state.closeWhenReady = false;
    if (dialog && !dialog.hidden) dialog.hidden = true;
    root.classList.remove('bm-sf-locked');
    state.inert.forEach(function (x) { x[0].inert = x[1]; });
    state.inert = [];
    setAttr(document.querySelector('.bm-sf-bar__open'), 'aria-expanded', 'false');
  }
  function openDialog() {
    var d = dialogEl();
    if (!d.hidden) return;
    state.lastFocus = document.activeElement;
    d.hidden = false;
    root.classList.add('bm-sf-locked');
    state.inert = [];
    Array.prototype.forEach.call(document.body.children, function (n) {
      if (n === d || n.tagName === 'SCRIPT' || n.tagName === 'STYLE' || n.tagName === 'LINK') return;
      state.inert.push([n, n.inert]);
      n.inert = true;
    });
    setAttr(document.querySelector('.bm-sf-bar__open'), 'aria-expanded', 'true');
    previewOffset();
    chipFade();
    d.querySelector('.bm-sf-dialog__scroll').scrollTop = 0;
    d.querySelector('.bm-sf-dialog__title').focus({ preventScroll: true });
  }
  function closeDialog(toResults) {
    if (!isOpen()) return;
    release();
    if (toResults) {
      var b = document.getElementById('bm-sf-bar');
      if (b && !slotScroll(b)) window.scrollTo({ top: Math.max(0, window.scrollY + b.getBoundingClientRect().top - stickyTop()), behavior: 'auto' });
    }
    var rail = state.facets;
    focusFirst([state.lastFocus, document.querySelector('.bm-sf-bar__open'), rail && rail.querySelector('.ais-SortBy-select')], document.querySelector('#algolia-shopify-instantsearch .ais-block'));
  }
  // Leaving the page with the dialog open must not leave a locked, inert page in the back/forward cache; a page
  // restored from it is put right again. Neither moves focus or scroll.
  window.addEventListener('pagehide', release);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { release(); schedule(); } });
  // The theme preview's bar is fixed at the bottom on unpublished themes; the dialog stops above it.
  function previewOffset() {
    if (!dialog) return;
    var bottom = 0, pb = document.getElementById('PBarNextFrameWrapper');
    if (pb) { var r = pb.getBoundingClientRect(); if (r.height > 0 && r.height < innerHeight / 2 && getComputedStyle(pb).position === 'fixed') bottom = Math.ceil(r.height); }
    dialog.style.setProperty('--bm-sf-preview-bottom', bottom + 'px');
  }
  function focusables(d) {
    return Array.prototype.filter.call(d.querySelectorAll('button, a[href], input, select, [tabindex]'), function (n) {
      return !n.disabled && n.tabIndex >= 0 && n.getClientRects().length && getComputedStyle(n).visibility !== 'hidden';
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!dialog || dialog.hidden) return;
    if (e.key === 'Escape') {
      if (e.target.matches && e.target.matches('.bm-sf-search__input') && e.target.value) return; // the box clears first
      e.preventDefault();
      e.stopImmediatePropagation();
      closeDialog(false);
      return;
    }
    if (e.key === 'Tab') {
      var stops = focusables(dialog), i = stops.indexOf(document.activeElement);
      if (!stops.length) { e.preventDefault(); return; }
      if (e.shiftKey && i <= 0) { e.preventDefault(); stops[stops.length - 1].focus(); }
      else if (!e.shiftKey && (i === stops.length - 1 || i < 0)) { e.preventDefault(); stops[0].focus(); }
    }
  }, true);

  // The bar sticks under the site's sticky header, wherever that header is at the moment.
  function stickyTop() {
    var h = document.querySelector('.main-header__sticky') || document.querySelector('header.bmh') || document.querySelector('#SiteHeader');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return Math.max(0, Math.min(200, Math.round(h.getBoundingClientRect().bottom)));
  }
  var topFrame = 0;
  function trackTop() {
    if (topFrame) return;
    topFrame = requestAnimationFrame(function () {
      topFrame = 0;
      if (!isPhone()) return;
      var v = stickyTop() + 'px';
      if (root.style.getPropertyValue('--bm-sf-top') !== v) root.style.setProperty('--bm-sf-top', v);
    });
  }

  /* ---------- 17 Oct, search-mobile-bar: phones swap the menu row for this bar, as collection pages do ----------
   * The owner is buildmat-header.js, the same controller bm-filters-mobile.js asks (stickyController: measure,
   * getCollectionScrollTarget). Two hooks opt /search in: data-bmh-context-row on the bar, data-bmh-context-grid on the
   * app's hits container. Over the results the header sets body[data-bm-sticky-context=collection], hides the menu row
   * and bm-search-page.css sticks the bar at --bmh-slot-top. No owner, desktop, no results or a header that does not
   * read the hooks yet: no hooks, and the bar keeps its own sticky top as before (so the files can ship in any order). */
  var slotKey = '', slotsMissing = false;
  function headerOwner() {
    var h = document.querySelector('header.bmh[data-bm-mobile-sticky-slots]');
    var o = h && h.stickyController;
    return o && typeof o.measure === 'function' && typeof o.getCollectionScrollTarget === 'function' ? o : null;
  }
  function slots(off) {
    var b = document.getElementById('bm-sf-bar');
    var g = document.querySelector('#algolia-shopify-instantsearch .ais-hits-container');
    var owner = headerOwner();
    var on = !off && !state.off && !slotsMissing && !!(owner && b && g && isPhone() && !b.hidden);
    if (on) { flag(b, 'data-bmh-context-row', true); flag(g, 'data-bmh-context-grid', true); }
    else Array.prototype.forEach.call(document.querySelectorAll('[data-bmh-context-row],[data-bmh-context-grid]'), function (n) {
      n.removeAttribute('data-bmh-context-row'); n.removeAttribute('data-bmh-context-grid');
    });
    // the header re-reads its regions when the bar arrives, leaves or the results change; its own observers do the rest
    var key = on ? 'on:' + state.hits : '';
    if (key !== slotKey) {
      slotKey = key;
      if (owner) owner.measure();
      // a header without the hooks puts no home marker before the bar: drop them, so the bar keeps its own sticky top
      if (on && !(b.previousElementSibling && b.previousElementSibling.classList.contains('bmh-context-origin'))) { slotsMissing = true; slots(); }
    }
  }
  // Show results: the bar goes to its slot over the results (the collection's scroll target); already there, it stays.
  function slotScroll(b) {
    var owner = b.hasAttribute('data-bmh-context-row') ? headerOwner() : null;
    if (!owner) return false;
    owner.measure();
    if (document.body.getAttribute('data-bm-sticky-context') === 'collection') return true;
    var y = owner.getCollectionScrollTarget();
    if (y == null || !isFinite(y)) return false;
    window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    return true;
  }

  // 1 Nov (c338): a tick searches at once, and the count only changes when the app's answer arrives. While a search
  // is out, Show results says "Updating results…" (the collection drawer's words), then shows the new total. The state
  // is the app's own InstantSearch status, read after each of its renders: no search call of our own.
  function searchStatus() { try { return window.algoliaShopify.instantsearch.search.status || 'idle'; } catch (e) { return 'idle'; } }
  function searching() { var s = searchStatus(); return s === 'loading' || s === 'stalled'; }
  function listen() {
    if (state.listening) return;
    var s = null;
    try { s = window.algoliaShopify.instantsearch.search; } catch (e) { s = null; }
    if (s && typeof s.on === 'function') { s.on('render', schedule); state.listening = true; }
  }
  function counts() {
    var n = state.hits;
    var words = n == null ? '' : fmt(n) + ' ' + (n === 1 ? WORDS.result : WORDS.results);
    var b = document.getElementById('bm-sf-bar');
    if (b) {
      text(b.querySelector('.bm-sf-bar__count'), words);
      var badge = b.querySelector('.bm-sf-bar__badge');
      text(badge, String(state.chosen));
      badge.classList.toggle('bm-sf-bar__badge--none', !state.chosen);
      setAttr(b.querySelector('.bm-sf-bar__open'), 'aria-label', WORDS.filterSort + (state.chosen ? ', ' + state.chosen + ' ' + WORDS.selected : ''));
      // hidden until the first count arrives, so it never redraws its row in view
      flag(b, 'hidden', n == null || (n === 0 && !state.chosen));
    }
    if (dialog) {
      var show = dialog.querySelector('.bm-sf-dialog__show'), status = searchStatus(), busy = status === 'loading' || status === 'stalled';
      text(show, busy ? WORDS.updating : WORDS.showResults + (n == null || status === 'error' ? '' : ' (' + fmt(n) + ')'));
      setAttr(show, 'aria-busy', String(busy));
      if (busy) setAttr(show, 'aria-label', WORDS.updatingName); else if (show.hasAttribute('aria-label')) show.removeAttribute('aria-label');
      if (!busy && state.closeWhenReady) {
        state.closeWhenReady = false;
        if (status !== 'error') requestAnimationFrame(function () { if (isOpen()) closeDialog(true); });
      }
    }
    var r = document.getElementById('algolia-shopify-instantsearch');
    if (r) r.classList.toggle('bm-sf-none', n === 0 && !state.chosen);
  }

  var frame = 0;
  function schedule() { if (!frame) frame = requestAnimationFrame(tidy); }
  function tidy() {
    frame = 0;
    if (state.off) return;
    var p = page();
    queryHeading(p);
    var rail = facets(p);
    if (!p || !rail) return;
    railHead(p, rail);
    chips(rail);
    lists();
    familyCounts();
    if (PRICE_SLIDER) slider(rail);
    balanceSearchBrandLogos(rail);
    var b = bar(p);
    place(p, rail);
    headingPlace(rail, b);
    chipFade();
    listen();
    counts();
    trackTop();
    slots();
    // the app can redraw the footer more than once per change, so this holds for a short window
    if (state.refocus && Date.now() > state.refocusUntil) state.refocus = null;
    if (state.refocus) {
      var a = document.activeElement;
      var target = rail.querySelector('.bm-sf-price ' + state.refocus);
      if (target && (!a || a === document.body || !a.isConnected)) {
        target.focus({ preventScroll: true });
        if (target.setSelectionRange) { var end = target.value.length; target.setSelectionRange(end, end); }
      }
    }
    // a family ticked from the keyboard keeps the keyboard on its row after the list redraws
    if (state.familyFocus && Date.now() > state.familyFocus.until) state.familyFocus = null;
    if (state.familyFocus) {
      var now = document.activeElement;
      var box = rail.querySelector('[data-bm-family="' + state.familyFocus.name.replace(/"/g, '\\"') + '"] input');
      if (box && box !== now && (!now || now === document.body || !now.isConnected)) box.focus({ preventScroll: true });
    }
  }
  var observer = new MutationObserver(schedule);
  function start() {
    var r = document.getElementById('algolia-shopify-instantsearch');
    if (r) observer.observe(r, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  phone.addEventListener('change', schedule);
  window.addEventListener('scroll', trackTop, { passive: true });
  window.addEventListener('resize', function () { trackTop(); previewOffset(); }, { passive: true });

  /* ---------- 18 Oct, sticky-bar-over-menu (Carlos): the collection's behaviour (bm-filters-mobile.js) ----------
   * On phones the bar rides over the header's menu row instead of sliding under it (rule in bm-search-page.css).
   * data-bm-bar-over is on while the bar's home is at or below the slot, so it holds there natively before the header's
   * swap; it stays through the swap and goes when the bar leaves at the results' end or a header menu opens (the menu
   * panel lives in the header's layer). Header and slot are buildmat-header.js's, read only. */
  // this file can run before the header is parsed: set up once the document is
  function barOver() {
    var header = document.querySelector('header.bmh'), overFrame = 0, seenBar = null;
    if (!header) return;
    function menuOpen() {
      var nav = header.querySelector('.bmh__nav'), active = document.activeElement;
      return !!(header.querySelector('[aria-expanded="true"],.mm-vp[data-state="open"]') || (nav && active && nav.contains(active) && active.matches(':focus-visible')));
    }
    function over() {
      var b = document.getElementById('bm-sf-bar');
      if (!b) return;
      var home = b.previousElementSibling, held = b.hasAttribute('data-bm-bar-over'), on = held;
      if (!isPhone() || !b.hasAttribute('data-bmh-context-row') || !header.hasAttribute('data-bm-mobile-sticky-slots') || !home || !home.classList.contains('bmh-context-origin') || menuOpen()) on = false;
      else {
        var grid = document.querySelector('[data-bmh-context-grid]'), bounds = grid && grid.getBoundingClientRect();
        if (!bounds || bounds.height <= 0) on = false;
        else {
          var first = seenBar !== b; seenBar = b;
          var slot = parseFloat(document.body.style.getPropertyValue('--bmh-slot-top')) || 0;
          // Bound the overlay by the results container; the header's context attribute can lag a fast scroll.
          // First observation inside results opts in; a bar already released below results keeps the normal reentry reveal.
          on = home.getBoundingClientRect().top >= slot - 1 || ((held || first) && bounds.bottom > slot + b.getBoundingClientRect().height);
        }
      }
      flag(b, 'data-bm-bar-over', on);
    }
    // scroll: two frames, so the header's own frame has run and its swap is already in the context attribute
    function later() { if (!overFrame) overFrame = requestAnimationFrame(function () { overFrame = requestAnimationFrame(function () { overFrame = 0; over(); }); }); }
    new MutationObserver(over).observe(document.body, { attributes: true, attributeFilter: ['data-bm-sticky-context'] });
    new MutationObserver(over).observe(header, { subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'data-state', 'data-bm-mobile-sticky-slots'] });
    // the bar gains or loses its context-row hook as the results arrive (slots above)
    var r = document.getElementById('algolia-shopify-instantsearch');
    if (r) new MutationObserver(later).observe(r, { subtree: true, attributes: true, attributeFilter: ['data-bmh-context-row', 'hidden'] });
    window.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later, { passive: true });
    phone.addEventListener('change', later);
    document.addEventListener('focusin', later);
    document.addEventListener('focusout', later);
    later();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barOver); else barOver();
})();
